import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
declare var google: any;

// const BASEURL = 'http://localhost:8000/api/prestige';
const BASEURL = 'https://locator.d-solcatalog.com/api/prestige';

@Injectable({
  providedIn: 'root'
})
export class LocatorService {
  
  closest: any = [];

  constructor(
    private httpClient: HttpClient
  ) { }

  cities: any = [];

  GetAllStudents(clientID) {
    return this.httpClient.get(`${BASEURL}/pro/all/${clientID}`);
  }

  GetAllStudents2(clientID) {
    return this.httpClient.get(`${BASEURL}/pro/2/all/${clientID}`);
  }

  GetAllPros() {
    return this.httpClient.get(`${BASEURL}/kpro/all`);
  }

  SearchPro(form): Observable<any> {
    return this.httpClient.get(`${BASEURL}/kpro/search/${form.firstname}/${form.lastname}/${form.clientid}`);
  }

  Deg2Rad(deg) {
    return deg * Math.PI / 180;
  }

  getlatLong(address): Promise<any> {
    var geocoder = new google.maps.Geocoder();
    return new Promise(async (resolve, reject) => {
      await geocoder.geocode({ 'address': address }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          resolve(results[0]);
        } else {
          reject(status)
        }
      });
    })
  }

  UserLocation(address) {
    var geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({ 'address': address }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          resolve (this.NearestCity(results[0].geometry.location.lat(), results[0].geometry.location.lng()));
        } else {
          reject(status);
        }
      })
    })
  }

  PythagorasEquirectangular(lat1, lon1, lat2, lon2, unit) {
    // lat1 = this.Deg2Rad(lat1);
    // lat2 = this.Deg2Rad(lat2);
    // lon1 = this.Deg2Rad(lon1);
    // lon2 = this.Deg2Rad(lon2);
    // var R = 6371; // km
    // var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
    // var y = (lat2 - lat1);
    // var d = Math.sqrt(x * x + y * y) * R;
    // return d;
    var radlat1 = Math.PI * lat1 / 180
    var radlat2 = Math.PI * lat2 / 180
    var radlon1 = Math.PI * lon1 / 180
    var radlon2 = Math.PI * lon2 / 180
    var theta = lon1 - lon2
    var radtheta = Math.PI * theta / 180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180 / Math.PI
    dist = dist * 60 * 1.1515
    if (unit == "K") { dist = dist * 1.609344 }
    if (unit == "N") { dist = dist * 0.8684 }
    return dist
  }

  NearestCity(latitude, longitude) {
    // console.log(latitude, longitude)
    // var minDif = 99999;
    // var closest = [];

    for (let index = 0; index < this.cities.length; ++index) {
      //console.log(this.cities[index].lat, this.cities[index].long)
      this.cities[index].distance = this.PythagorasEquirectangular(latitude, longitude, this.cities[index].lat, this.cities[index].long, 'K');
      // if (dif < minDif) {
      //   minDif = dif;
      //   this.closest.push(this.cities[index]);
      // }
    }
    console.log(this.cities);
    return this.cities.sort((a, b) => {
      return a.distance - b.distance;
    }).slice(0, 10);

    // alert(this.cities[closest]); 
  }

  SaveSearch(body) {
    return this.httpClient.post(`${BASEURL}/pro/save`, body);
  }
  
}
